<template>
  <div class="vx-col w-full mb-base">
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'
import axios from '@/axios.js'

let timerInterval
export default {
  props: {
    createPayroll: {
      type: Object,
      required: false
    },
    isValidate7: {
      type: Boolean,
      required: false
    }

  },
  data() {
    return {
      counter: 0,
    }
  },
  watch: {
    isValidate7(value) {
      if (value)
        this.onConfirmClosePeriod()
    }
  },
  computed: {
    getAllLogHours() {
      return this.$store.state.payroll.getAllLogHours
    },
    tenantName() {
      return (id) => this.$store.getters['tenants/tenantName'](id)
    },
  },
  methods: {
    onConfirmClosePeriod() {
      Swal.fire({
        title: 'Would you like to close the payroll period ' + moment(this.createPayroll.payOutDate).format('DD MMM YYYY') + '?',
        text: "You will not be able to revert this!",
        icon: 'warning',
        customClass: {
          icon: "no-before-icon",
        },
        showCancelButton: true,
        confirmButtonColor: '3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Close Period'
      }).then((result) => {
        if (result.isConfirmed) {

          this.onOpenWaitingDialog()
        }
      })
      // this.$confirm('Would you like to close the payroll period ' + moment(this.createPayroll.payOutDate).format('DD MMM YYYY'), 'Confirm?')
      // .then((t) => {
      //     this.$vs.loading()
      //     this.passwordToOpen = t
      //     this.onOpenWaitingDialog()
      // })
    },
    onOpenWaitingDialog() {
console.log('GETLOGHOURS')
console.log(this.getAllLogHours)
      Swal.fire({
        title: 'Closing Payroll Period!',
        html: '<b></b>',
        timer: this.getAllLogHours.length * 1296,
        showConfirmButton: false,
        didOpen: () => {

          this.onClosePeriod()
          const b = Swal.getHtmlContainer().querySelector('b')
          timerInterval = setInterval(() => {
            if (Swal.getTimerLeft() > 1000)
              b.textContent = 'Generating Payslip...'
            else
              b.textContent = 'Closing...'
          }, 100)

        },
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {

        }
      })
    },
    onClosePeriod() {

      var curdate = new Date().toLocaleString()
      let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId)

      var logoPath = ''
      var u = 0
      this.counter = 0

      if (tenant.photoId != null) {
        this.$store.dispatch('getFile', tenant.photoId) //Get filePath of Company Logo
          .then((response) => {
            logoPath = response.data.path

          })
      }
      //Generate Payslip
      let user = []
      for (var u = 0; u < this.getAllLogHours.length; u++) {
        user.push(this.getAllLogHours[u].userId)
      }
      if (user.length == 0) return
      const data1 = {
        serverName: tenant.secretKey,
        dbName: tenant.apiKey,
        userName: '',
        password: '',
        companyCode: tenant.code,
        companyName: tenant.name,
        address: tenant.address,
        photoURL: logoPath,
        createPayrollId: this.createPayroll.createPayrollId,
        printedBy: this.$store.state.AppActiveUser.uid,
        reportName: ['PayrollPayslip'],
        payOutDate: moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
        creditDate: moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
        passwordToOpen: null,
        monthName: '',
        yearScope: '',
        reportType: 'CURRENT',
        userId: user
      }
      const data2 = {
        serverName: tenant.secretKey,
        dbName: tenant.apiKey,
        userName: '',
        password: '',
        companyCode: tenant.code,
        companyName: tenant.name,
        address: tenant.address,
        photoURL: logoPath,
        createPayrollId: this.createPayroll.createPayrollId,
        printedBy: this.$store.state.AppActiveUser.uid,
        reportName: ['BIR2316'],
        payOutDate: moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
        creditDate: moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
        passwordToOpen: null,
        monthName: '',
        yearScope: this.createPayroll.calendarYear,
        reportType: 'BIR2316',
        userId: user
      }

      const options = {
        responseType: 'blob',
        onDownloadProgress: progressEvent => {
          const p = Math.round(progressEvent.event.loaded / (progressEvent.event.total === 0 ? progressEvent.event.loaded : progressEvent.event.total)) * 100
          this.counter = p
          this.$vs.loading()
        },
      }
      axios.post('/api/reports/generatereports', data1)//PRINTING PAYSLIP
        .then((response) => {
          if (response.status === 200) {
            console.log("DONE PAYSLIP")
            const data = {
              payrollId: this.createPayroll.createPayrollId,
              dateClosed: curdate,
              processedBy: this.$store.state.AppActiveUser.uid
            }
            this.$vs.loading()
            this.$store.dispatch('payroll/ClosedPayroll', data)
              .then((res) => {
                this.$vs.loading.close()
                if (res.status === 200) {


                  Swal.fire({
                    title: 'Done',
                    html: 'Payroll cut-off ' + this.createPayroll.cutOffStartDate + ' to ' + this.createPayroll.cutOffEndDate + ' has been closed',
                    icon: 'success',
                    timer: 2000,
                    timerProgressBar: true,
                    didOpen: () => {

                      if (this.createPayroll.createPayrollTypeId == 4)//FINAL PAY
                       {
                        this.$vs.loading()
                            axios.post('/api/reports/generatereports', data2)//PRINTING BIR 2316
                            .then((response) => {
                                if(response.status === 200)
                                {
                                  var zipFileName = tenant.code + '_BIR2316.zip'
                                  var pDate = moment(this.createPayroll.payOutDate).format('YYYYMMDD')
                                  axios.get(`/api/reports/DownloadFile?dbName=${tenant.code}&fileName=${zipFileName}&payOutDate=${pDate}&reportType=BIR2316`
                                    , { reportProgress: true, responseType: 'blob' })
                                    .then((response) => {
                                      this.$vs.loading.close()
                                      const url = window.URL.createObjectURL(new Blob([response.data]));
                                      const link = document.createElement('a');
                                      link.href = url;
                                      link.setAttribute('download', tenant.code + '_' + moment(this.createPayroll.payOutDate).format('YYYYMMDD') + '.zip');
                                      document.body.appendChild(link);
                                      link.click();

                                      Swal.fire({ title: 'Done',
                                        html: 'BIR 2316 Reports Generated',
                                        icon: 'success',
                                        timer: 2000,
                                        timerProgressBar: true,
                                        didOpen: () => {
                                          this.$router.go()
                                        } })
                                    })
                                    this.$vs.loading.close()
                                    this.$router.go()
                                    .catch((error) => {
                                      this.$alert(error.message, 'Error', 'error')
                                    })
                                // }
                                // else
                                //

                              }
                            })

                          } else
                          this.$router.go()
                    },
                  })


                }
              })
              .catch((err) => {
                this.$vs.loading.close()
                console.log(err)
              })

          }
        })
        .catch((err) => {
          this.$vs.loading.close()
          console.log(err)
        })



      //Closed Payroll

    },

  },
  components: {
    Swal,
  }
}
</script>
